import * as axerealJson from './axereal.json';
import * as blastJson from './blast.json';
import * as blockpulseJson from './blockpulse.json';
import * as cenitzJson from './cenitz.json';
import * as howhenJson from './howhen.json';
import * as investJson from './invest.json';
import * as lesaffreJson from './lesaffre.json';
import * as pbaJson from './pba.json';
import * as stomeaJson from './stomea.json';
import * as vivaltoJson from './vivalto.json';
import * as yeastJson from './yeast.json';

export const blockpulse = blockpulseJson;
export const blast = blastJson;
export const howhen = howhenJson;
export const axereal = axerealJson;
export const pba = pbaJson;
export const cenitz = cenitzJson;
export const invest = investJson;
export const stomea = stomeaJson;
export const lesaffre = lesaffreJson;
export const vivalto = vivaltoJson;
export const yeast = yeastJson;
